<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><a class="page" id="pii"></a><a class="page" id="piii"></a>Wading Right In</h1>
<h1 class="bk1">Discovering the Nature of Wetlands</h1>
<p class="bkau">Catherine Owen Koning and Sharon M. Ashworth</p>
<p class="bkau1"><i>with illustrations by</i> Catherine Owen Koning</p>
<p class="bkpub">The University of Chicago Press</p>
<p class="bkpub1">Chicago and London</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-koning-0003.vue?3b49bca2